import React from 'react';
import { Link } from 'react-router-dom';
import { useMemberAuth } from '../../hooks/useMemberAuth';
import { Eye, User, Calendar } from 'lucide-react';

const MemberDashboard = () => {
  const { member } = useMemberAuth();

  const affiliationDate = member?.affiliation_date
    ? new Date(member.affiliation_date).toLocaleDateString('pt-BR')
    : null;

  return (
    <div className="space-y-6">
      {/* Welcome */}
      <div className="bg-brand-brown rounded-2xl p-6 text-white shadow-md">
        <p className="text-brand-beige text-sm">Bem-vindo(a) de volta,</p>
        <h2 className="text-2xl font-display font-bold text-brand-cream mt-1">
          {member?.name}
        </h2>
        {member?.registration_number && (
          <p className="text-brand-beige text-sm mt-1">
            Matrícula: <span className="font-semibold text-brand-cream">{member.registration_number}</span>
          </p>
        )}
        {affiliationDate && (
          <p className="text-brand-beige text-sm mt-1 flex items-center">
            <Calendar className="h-4 w-4 mr-1" />
            Associado desde {affiliationDate}
          </p>
        )}
      </div>

      {/* Quick links */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <Link
          to="/transparencia"
          target="_blank"
          rel="noopener noreferrer"
          className="bg-white rounded-xl border-2 border-brand-beige p-6 hover:border-brand-brown hover:shadow-md transition-all group"
        >
          <div className="flex items-center space-x-4">
            <div className="h-12 w-12 rounded-xl bg-brand-cream flex items-center justify-center group-hover:bg-brand-brown transition-colors">
              <Eye className="h-6 w-6 text-brand-brown group-hover:text-brand-cream transition-colors" />
            </div>
            <div>
              <h3 className="font-semibold text-brand-brown">Portal de Transparência</h3>
              <p className="text-sm text-gray-500 mt-0.5">
                Consulte as despesas e finanças da associação
              </p>
            </div>
          </div>
        </Link>

        <Link
          to="/associado/perfil"
          className="bg-white rounded-xl border-2 border-brand-beige p-6 hover:border-brand-brown hover:shadow-md transition-all group"
        >
          <div className="flex items-center space-x-4">
            <div className="h-12 w-12 rounded-xl bg-brand-cream flex items-center justify-center group-hover:bg-brand-brown transition-colors">
              <User className="h-6 w-6 text-brand-brown group-hover:text-brand-cream transition-colors" />
            </div>
            <div>
              <h3 className="font-semibold text-brand-brown">Meu Perfil</h3>
              <p className="text-sm text-gray-500 mt-0.5">
                Atualize seus dados cadastrais
              </p>
            </div>
          </div>
        </Link>
      </div>
    </div>
  );
};

export default MemberDashboard;
